var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFitnessWeightlifting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2656 22.2656C22.2656 23.9191 22.9225 25.5048 24.0916 26.674C25.2608 27.8432 26.8465 28.5 28.5 28.5C30.1535 28.5 31.7392 27.8432 32.9084 26.674C34.0775 25.5048 34.7344 23.9191 34.7344 22.2656C34.7344 20.6122 34.0775 19.0264 32.9084 17.8573C31.7392 16.6881 30.1535 16.0313 28.5 16.0312C26.8465 16.0313 25.2608 16.6881 24.0916 17.8573C22.9225 19.0264 22.2656 20.6122 22.2656 22.2656V22.2656Z",
    stroke: "currentColor",
    strokeWidth: 2.65116,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94141 21.375C9.16151 26.9647 11.2287 32.3236 14.8195 36.613C16.6397 38.5906 18.8794 40.1358 21.3745 41.135V55.2188",
    stroke: "currentColor",
    strokeWidth: 2.65116,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9377 14.6252C42.301 14.9441 41.7745 15.4465 41.4261 16.0675C41.0777 16.6886 40.9234 17.3998 40.9831 18.1094C40.9831 18.1949 41.5602 26.7639 36.9456 31.787C36.1648 32.6095 35.2591 33.3036 34.2619 33.8437H22.7407C21.7576 33.3107 20.862 32.6299 20.0855 31.825C15.4376 26.7852 16.0076 18.2614 16.0219 18.0975C16.0787 17.3893 15.9226 16.6803 15.5734 16.0616C15.2243 15.4429 14.6981 14.9427 14.0625 14.6252",
    stroke: "currentColor",
    strokeWidth: 2.65116,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.625 55.2188V41.135C38.1192 40.1385 40.3589 38.5967 42.18 36.6225C45.7727 32.3305 47.8401 26.968 48.0581 21.375",
    stroke: "currentColor",
    strokeWidth: 2.65116,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0957 8.91814C35.1425 6.52891 21.8615 6.52891 8.9082 8.91814",
    stroke: "currentColor",
    strokeWidth: 2.65116,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2188 12.4688C55.2188 13.4136 54.8434 14.3197 54.1753 14.9878C53.5072 15.6559 52.6011 16.0312 51.6562 16.0312C50.7114 16.0312 49.8053 15.6559 49.1372 14.9878C48.4691 14.3197 48.0938 13.4136 48.0938 12.4688V5.34375C48.0938 4.39892 48.4691 3.49278 49.1372 2.82468C49.8053 2.15658 50.7114 1.78125 51.6562 1.78125C52.6011 1.78125 53.5072 2.15658 54.1753 2.82468C54.8434 3.49278 55.2188 4.39892 55.2188 5.34375V12.4688Z",
    stroke: "currentColor",
    strokeWidth: 2.65116,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.90625 12.4688C8.90625 13.4136 8.53092 14.3197 7.86282 14.9878C7.19472 15.6559 6.28858 16.0312 5.34375 16.0312C4.39892 16.0312 3.49278 15.6559 2.82468 14.9878C2.15658 14.3197 1.78125 13.4136 1.78125 12.4688V5.34375C1.78125 4.39892 2.15658 3.49278 2.82468 2.82468C3.49278 2.15658 4.39892 1.78125 5.34375 1.78125C6.28858 1.78125 7.19472 2.15658 7.86282 2.82468C8.53092 3.49278 8.90625 4.39892 8.90625 5.34375V12.4688Z",
    stroke: "currentColor",
    strokeWidth: 2.65116,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitnessWeightlifting);
export default __webpack_public_path__ + "static/media/FitnessWeightlifting.664b15c2f11c5c496846765755e7fa45.svg";
export { ForwardRef as ReactComponent };